import { useLang } from 'hooks/lang';

import { actions } from 'entities';

import { Column, Label, ResponsiveOverlay } from 'components/Blocks';

import { useProjectProfile } from '../../context';

import { SingleProjectFile } from './ProjectFile';
import { NewProjectFile } from './NewFile';
import { TaskFiles } from './TaskFiles';
import { IconInput } from 'components/Inputs';
import { SearchIcon } from 'components/Icons';
import { useState } from 'react';
import { isSubstring } from 'utils/text';

interface ProjectFilesProps {
  isOpen: boolean;
  close: () => void;
}

export function ProjectFilesModal({ close, isOpen }: ProjectFilesProps) {
  const { project } = useProjectProfile();

  const [fileQuery, setFileQuery] = useState('');

  const { t } = useLang();

  const addFile = actions.projects.addFileToProject.use();

  const loading = addFile.loading;

  const handleCloseModal = () => {
    if (loading) return;

    close();
  };

  return (
    <ResponsiveOverlay
      className="max-w-full overflow-y-auto"
      isOpen={isOpen}
      width="min(90vw, 1060px)"
      title={t('attachments')!}
      placement="top"
      close={handleCloseModal}
      preventOpenAutoFocus
      allowEscape
      gap="6"
    >
      <IconInput icon={<SearchIcon />} value={fileQuery} onChangeDirect={setFileQuery} />

      <Column>
        <Label>{t('project-files')}</Label>

        {project.files
          .filter((f) => isSubstring(fileQuery.trim(), f.name))
          .map((file) => (
            <SingleProjectFile key={file.id} file={file} />
          ))}

        {!fileQuery.trim() && <NewProjectFile />}
      </Column>

      <TaskFiles fileQuery={fileQuery} />
    </ResponsiveOverlay>
  );
}
